<template>
  <div :class="[start ? 'start' : end ? 'end' : 'center', { full: width == 'full' }]">
    <slot />
  </div>
</template>

<script setup lang="ts">
const { width = 'normal' } = defineProps<{
  start?: boolean;
  end?: boolean;
  width?: 'full' | 'normal' | 'narrow';
}>();
</script>

<style scoped>
* {
  --width: v-bind('width == "narrow" ? "896px" : "1160px"');
}
.center {
  width: var(--width);
  max-width: 100vw;
  margin: 0 auto;
}

.full {
  width: 100%;
}

@media (min-width: 1201px) {
  .start {
    margin-inline-end: calc(calc(100vw - var(--width)) / 2);
  }
  .end {
    margin-inline-start: calc(calc(100vw - var(--width)) / 2);
  }
}

@media (min-width: 851px) and (max-width: 1200px) {
  .center {
    padding-inline: var(--space-7);
  }
  .start {
    margin-inline-start: calc(calc(100vw - var(--width)) / 2);
    padding-inline: 0 var(--space-7);
  }
  .end {
    margin-inline-end: calc(calc(100vw - var(--width)) / 2);
    padding-inline: var(--space-7) 0;
  }
}

@media (max-width: 850px) {
  div:not(.full) {
    padding-inline: var(--space-4);
  }
}
</style>